import React from 'react';

function ParentContractSetup() {
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-center border-b-2 pb-4 mb-6">
        <h1 className="text-3xl font-bold text-blue-900">Parent Contract Set Up</h1>
        <div>
          <button className="text-sm text-white bg-blue-700 px-4 py-2 rounded-md mr-2">
            Save
          </button>
          <button className="text-sm text-white bg-red-500 px-4 py-2 rounded-md">
            Delete
          </button>
          <button className="text-sm text-white bg-gray-500 px-4 py-2 rounded-md ml-2">
            Clear
          </button>
        </div>
      </div>

      {/* Form Section */}
      <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
        <div className="grid grid-cols-3 gap-6 mb-4">
          <div>
            <label className="text-gray-700 font-medium">Parent Contract ID</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-1"
            />
          </div>
          <div>
            <label className="text-gray-700 font-medium">Parent Contract Number</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-1"
            />
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              className="h-5 w-5 text-blue-600 focus:ring-2 focus:ring-blue-500"
            />
            <label className="ml-2 text-gray-700 font-medium">Active</label>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h2 className="text-xl font-bold text-blue-900 mb-4">Master Account</h2>
        <table className="min-w-full bg-white">
          <thead className="bg-gray-200">
            <tr>
              <th className="text-left py-3 px-4 font-medium text-gray-700">Master ID</th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">Contract #</th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">Act</th>
              <th className="text-left py-3 px-4 font-medium text-gray-700">Building Site</th>
              <th className="text-left py-3 px-4 font-medium text-gray-700"># dvc</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">---</td>
              <td className="border px-4 py-2">---</td>
              <td className="border px-4 py-2">---</td>
              <td className="border px-4 py-2">---</td>
              <td className="border px-4 py-2">---</td>
            </tr>
            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
}
console.log("Parent Contract Setup Loaded");
export default ParentContractSetup;